import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Tools|Merges|Rejected|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.MergeCandidates,
	portal: 'SP',
};

type LocNameStart = 'SPToolsMergesRejected';
export type SPToolsMergesRejectedLocNames =
	| `${LocNameStart}TitlePage`
	| `${LocNameStart}TitleTab`
	| `${LocNameStart}ContentNoCandidate`
	| `${LocNameStart}LabelCreated`
	| `${LocNameStart}LabelWinner`
	| `${LocNameStart}LabelLoser`
	| `${LocNameStart}LabelMessage`;

export const spToolsMergesRejectedLocs: LocDefs<SPToolsMergesRejectedLocNames> = {
	SPToolsMergesRejectedTitlePage: {
		defaultValue: 'Rejected Merges',
		description: 'Page Title',
		displayPath: `${pathStart}Page Title`,
		displayType: 'Title',
		legacyName: 'MergeCandidates/Tools.Merges.RejectedMerges.Title.RejectedMerges',
		...sharedProperties,
	},
	SPToolsMergesRejectedTitleTab: {
		defaultValue: 'Rejected Merges',
		description: 'Tab Title',
		displayPath: `${pathStart}Tab Title`,
		displayType: 'Title',
		legacyName: 'MergeCandidates/Tools.Merges.RejectedMerges.Title.Tab',
		...sharedProperties,
	},
	SPToolsMergesRejectedContentNoCandidate: {
		defaultValue: 'Candidate no longer exists',
		description: 'Text shown when a candidate no longer exists',
		displayPath: `${pathStart}Candidate no longer exists`,
		displayType: 'Content',
		legacyName: 'MergeCandidates/Tools.Merges.Content.NoCandidate',
		...sharedProperties,
	},
	SPToolsMergesRejectedLabelCreated: {
		defaultValue: 'Created',
		description: 'Column heading for: Created.',
		displayPath: `${pathStart}Created`,
		displayType: 'Label',
		legacyName: 'MergeCandidates/Tools.Merges.RejectedMerges.ColumnHeading.Created',
		...sharedProperties,
	},
	SPToolsMergesRejectedLabelWinner: {
		defaultValue: 'Winner',
		description: 'Column heading for: Winner.',
		displayPath: `${pathStart}Winner`,
		displayType: 'Label',
		legacyName: 'MergeCandidates/Tools.Merges.RejectedMerges.ColumnHeading.Winner',
		...sharedProperties,
	},
	SPToolsMergesRejectedLabelLoser: {
		defaultValue: 'Loser',
		description: 'Column heading for: Loser.',
		displayPath: `${pathStart}Loser`,
		displayType: 'Label',
		legacyName: 'MergeCandidates/Tools.Merges.RejectedMerges.ColumnHeading.Loser',
		...sharedProperties,
	},
	SPToolsMergesRejectedLabelMessage: {
		defaultValue: 'Message',
		description: 'Column heading for: Message.',
		displayPath: `${pathStart}Message`,
		displayType: 'Label',
		legacyName: 'MergeCandidates/Tools.Merges.RejectedMerges.ColumnHeading.Message',
		...sharedProperties,
	},
};

export type SPToolsMergesRejectedLocType = LocMap<SPToolsMergesRejectedLocNames>;
